










































































import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Welcome extends Vue {
  popShow: boolean = false;
  tab: any = [
    {
      img: require('../assets/youngimgs/showact.png'),
      path: `homeact?id=1`,
    },
    {
      img: require('../assets/youngimgs/Internetpublic.png'),
      path: `home?id=2`,
    },
  ];
}
